import Icon from '@/shared/components/Icon/Icon';
import { useWindowDimensions } from '@/shared/hooks/useWindowDimension';
import { useUser } from '@/shared/hooks/user';
import { Capacitor } from '@capacitor/core';
import { IonLabel, IonTabBar, IonTabButton, IonTabs } from '@ionic/react';
import { useLocation } from 'react-router';
import styles from './MobileTabsWrapper.module.css';
import { t } from 'i18next';

const ignoreMobileTabsConfiguration = ['/imprint', '/privacy-policies'];
const MobileTabsWrapper = ({ items, children }) => {
  const isApp = Capacitor.isNativePlatform();
  const { isMobileView } = useWindowDimensions();
  const location = useLocation();
  const user = useUser();
  const isNotAuthenticatedRoute = location.pathname === '/';
  const isHideTabsActive = ignoreMobileTabsConfiguration.includes(location.pathname);
  const isUserAuthenticated = user && user.uuid;
  const showTabs = !isNotAuthenticatedRoute && (isApp || isMobileView) && isUserAuthenticated && !isHideTabsActive;

  return (
    <IonTabs>
      {children}
      <IonTabBar slot="bottom" className={showTabs ? styles.tabBar : styles.hidden}>
        {items.map((item, index) => {
          return (
            <IonTabButton key={index} tab={index.toString()} href={item.url} className={styles.tabButton}>
              <IonLabel className={styles.tabLabel}>
                <Icon size="xmedium" color="white" src={`assets/icons/${item.icon}.svg`} className={styles.tabIcon} />
                <span className={styles.tabTitle}>{t(item.title)}</span>
              </IonLabel>
            </IonTabButton>
          );
        })}
      </IonTabBar>
    </IonTabs>
  );
};

export default MobileTabsWrapper;
